/* eslint-disable react/display-name */
// Lib
import React, { useMemo, forwardRef, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Select as MuiSelect } from '@mui/material';

// Components
import { ReactComponent as Arrow } from '../../../assets/svg/arrow.svg';

// Styles
import Feather from '../../Feather';
import { useStyles } from './SelectStyles';

const Select = forwardRef(
  (
    {
      width,
      items = [],
      onChange = () => {},
      className,
      label = '',
      required = false,
      classic = false,
      initialValue = '',
      error,
      disabled = false,
      placeholder = '',
      withRemoveIcon = false,
      name: selectName,
      ...props
    },
    ref,
  ) => {
    const { classes, cx } = useStyles({ classic, error, width });
    const [value, setValue] = useState(initialValue);

    useEffect(() => setValue(initialValue), [initialValue]);

    const handleChange = (event) => {
      setValue(event.target.value);
    };

    const id = useMemo(() => {
      let id = '';
      if (error) {
        id = 'select-error';
      }
      if (classic) {
        return `classic-select ${id}`.trim();
      }
      return `select ${id}`.trim();
    }, [classic, error]);

    return (
      <Box className={cx(classes.container, className)}>
        {label && (
          <Box className={classes.fieldLabel} mb={1}>
            {`${label} `}
            {required ? <span className={classes.required}>*</span> : ''}
          </Box>
        )}
        <FormControl fullWidth id={id} {...props}>
          <MuiSelect
            classes={{ disabled: classes.disabled }}
            disabled={disabled}
            ref={ref}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            IconComponent={classic ? undefined : Arrow}
            id="simple-select"
            value={value}
            onChange={handleChange}
            MenuProps={{ classes: { paper: classes.paper } }}
            renderValue={(selected) =>
              selected ? (
                <span>{selected}</span>
              ) : (
                <>
                  <span className={classes.selectPlaceholder}>
                    {placeholder}
                  </span>
                  {required && !label && (
                    <span className={classes.requiredWithGap}>*</span>
                  )}
                </>
              )
            }>
            {items?.map((item) => {
              const { title, label, name } = item;
              return (
                <MenuItem
                  onClick={onChange(title || item, selectName)}
                  key={title || name}
                  value={label || name}>
                  {label || name}
                </MenuItem>
              );
            })}
          </MuiSelect>
          {withRemoveIcon && (
            <Feather
              className={classes.removeIcon}
              type="close"
              onClick={onChange({ name: '' })}
            />
          )}
        </FormControl>
        {error && <div className={classes.error}>{error}</div>}
      </Box>
    );
  },
);

export default Select;
